'use client';

import { Button } from '@/components/ui/Button';
import { Icon } from '@/components/ui/Icon';
import styles from './AddressSummary.module.scss';

export interface AddressSummaryAddress {
  firstName: string;
  lastName: string;
  companyName?: string;
  streetAddress1: string;
  streetAddress2?: string;
  city: string;
  postalCode: string;
  countryArea?: string;
}

export interface AddressSummaryProps {
  address: AddressSummaryAddress;
  title?: string;
  showChangeButton?: boolean;
  onChangeClick?: () => void;
  changeLabel?: string;
  showDeliverySchedule?: boolean;
  hideName?: boolean;
}

export const AddressSummary = ({
  address,
  title,
  showChangeButton = false,
  onChangeClick,
  changeLabel = 'Change',
  hideName = false,
}: AddressSummaryProps) => {
  return (
    <div className={styles.wrapper} data-testid="address-summary">
      {title ? <h3 className={styles.title}>{title}</h3> : null}
      <address className={styles.address}>
        {hideName ? null : (
          <p className={styles.name}>
            {address.firstName} {address.lastName}
          </p>
        )}
        {address.companyName ? <p className={styles.name}>{address.companyName}</p> : null}
        <p>{address.streetAddress1}</p>
        {address.streetAddress2 ? <p>{address.streetAddress2}</p> : null}
        <p>
          {address.postalCode} {address.city}
          {address.countryArea ? `, ${address.countryArea}` : null}
        </p>
      </address>
      {showChangeButton ? (
        <Button
          variant="link"
          underline
          onClick={onChangeClick}
          className={styles.changeButton}
          iconAfter={<Icon name="chevron-right" size={14} />}
          data-testid="change-address"
        >
          {changeLabel}
        </Button>
      ) : null}
    </div>
  );
};
